import React from "react";
import Tabs from './../../components/tabs.js';

export default class Serviceparams extends React.Component {
	constructor(props) {
		super(props);
			const {params} = props.project;
	    this.state = {
				params:params
		 	}
	    this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleTabChange = this.handleTabChange.bind(this);
			this.handleTabContentChange = this.handleTabContentChange.bind(this);
	}

  tabnav = (content,index) => { //className={()=>{xxx}}
			if(content.defaultCheck){
				return 'nav-item nav-link active';
			}else{
				return 'nav-item nav-link';
			}
  }

  tabitem = (content,index) => { //className={()=>{xxx}}
			if(content.defaultCheck){
				return 'd-block';
			}else{
				return 'd-none';
			}
  }

  handleInputChange(event) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;
		let { params } = this.state;
		params.map((p,i)=>{
			if(p.content.type==='list'){
				p.content.child.map((c,n)=>{
					if(c.type==='radio'){
						if(c.name===name) c.defaultCheck = false;
						if(c.name===name && c.value===value) c.defaultCheck = true;
					}
					if(c.type==='number' || c.type==='text'){
						if(c.name===name) c.value = value;
					}
				});
			}
			return p;
		});

		params = Object.assign(this.state.params,params);

		this.setState({
			params:params
		})

  }

	handleTabChange(event){
		//console.log(event)
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;
		let { params } = this.state;
		params.map((p,i)=>{
			if(p.content.type==='tabs'){
				p.content.child.map((c,n)=>{
					if(c.name===name){
						c.defaultCheck = false;
						if(c.value===value)	c.defaultCheck = true;
						return;
					}
				});
			}
			return p;
		});

		params = Object.assign(this.state.params,params);

		this.setState({
			params:params
		})

	}



	handleTabContentChange(event){
		//console.log(event)
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;
		const type = target.type;
		let { params } = this.state;
		params.map((p,i)=>{
			if(p.content.type==='tabs'){
				p.content.child.map((c,n)=>{
					c.tabcontent.map((tab,j)=>{
						if(typeof(tab.name) !=='undefined' && tab.type==='number' && tab.name===name){
							tab.value = value;
						}
						if(typeof(tab.input) !=='undefined'){
								tab.input.map((input,i)=>{
									if(input.name===name){
										input.defaultCheck = false;
										if(input.value===value) input.defaultCheck = true;
									}
								});
						}
					});
				});
			}
		});

		params = Object.assign(this.state.params,params);

		this.setState({
			params:params
		})

	}



	render() {
		const {params} = this.state;

			return(
				<div className=" mt-3 p-3">
				<Tabs activeclass="nav-item nav-link active" secondclass="nav-item nav-link " navclass="col-3 nav flex-column nav-pills" contentclass="col-9 border-left">
					{
						params.map((p,i)=>{
							return (
								<div name={p.text + ' ' + p.title} key={i}>
								{ p.content.type==='list' &&	p.content.child.map((c,n)=>{
										return(<div key={n}>
						            <label>
						              <input type={c.type} name={c.name} value={c.value} checked={c.defaultCheck} onChange={this.handleInputChange} /> {c.text} <br /><small className="text-muted">{c.title}</small>
						            </label>
										</div>)
									})
								}
							  {
									(p.content.type==='tabs') &&
											<div className="row">
												<ul className="col-4 nav flex-column nav-pills">
												{
													p.content.child.map((c,n)=>{
								            return(
								                   <li key={n} className={ this.tabnav(c,n) }>
																		 <label><input type={c.type} name={c.name} value={c.value} checked={c.defaultCheck}  onChange={this.handleTabChange} /> {c.text} <br /><small>{c.title}</small></label>
																	 </li>
															)
														})
												}
												</ul>
												<div className="col-8 border-left">
												{
													p.content.child.map((c,n)=>{
								            return(
						                   <div className={ this.tabitem(c,n) } key={n}>
																 {
																	  c.tabcontent.map((tab,j)=>{
																		if(typeof(tab.input)==='undefined'){
																			return(<p key={j}>{tab.text} <br /><small className="text-muted">{tab.title}</small><br /> <label key={j}>  <input type={tab.type} value={tab.value} name={tab.name}  onChange={this.handleTabContentChange}   />  </label></p>)
																		}else{
																		 return(
																			 <p key={j}>
																				 <span>{tab.text} <br /><small className="text-muted">{tab.title}</small></span><br />
																				 {
																						 tab.input.map((input,k)=>{
						 																		 return(<label key={k} className="mr-3" temp={input.defaultCheck.toString()}> <input type={input.type} value={input.value} checked={input.defaultCheck} name={input.name} onChange={this.handleTabContentChange} /> {input.value} </label>)
																							 })
										                     }
																			 </p>
																		 )
																		}
																	 })
																 }
															 </div>
								            )
													})
												}
										 		</div>
											</div>
										}
								</div>
							)
						})
					}
				</Tabs>
				</div>
				)
	}

}



// WEBPACK FOOTER //
// ./src/apps/console/project_service_params.js